export default __webpack_public_path__ + "static/media/back.a17ba737.png";